import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";

function JobCard({ Jobs }) {
    const { t } = useTranslation();
    const lang = Cookies.get("i18next") || "en";

    return (
        <Card 
            sx={{
                display: "flex", 
                flexDirection: "column", 
                alignItems: "center", 
                gap: 2, 
                maxWidth: "100%", 
                margin: "16px auto", // تباعد أفضل حول الكارد
                padding: 2,
                boxShadow: 3, // ظل خفيف
                borderRadius: "8px", // إضافة زوايا دائرية للكارد
                transition: "transform 0.3s ease", // إضافة تأثير عند التفاعل مع الكارد
                '&:hover': {
                    transform: "scale(1.05)", // تكبير الكارد عند التفاعل
                    boxShadow: 6, // زيادة الظل عند التفاعل
                }
            }}
        >
            {/* صورة الوظيفة */}
            <CardMedia
                component="img"
                sx={{
                    // width: 200, // عرض مرن للصورة
                    height: 150, // ارتفاع مرن للصورة
                    borderRadius: "8px", // زوايا دائرية للصورة
                    objectFit: "cover", // ملء الصورة بشكل مناسب
                    boxShadow: 1, // إضافة ظل للصورة
                }}
                image={Jobs.image ? `${process.env.REACT_APP_API_KEY}images/${Jobs.image}` : "/logo.png"}
                alt={Jobs.titleArabic || t("Default Image")}
            />

            {/* محتوى الوظيفة */}
            <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold',background:"#e5e7e9",padding:"1px 5px",borderRadius:"3px",textAlign:"center" }} gutterBottom>
                    {lang === "ar" ? Jobs.titleArabic : Jobs.titleEnglish}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {`${t("Advertiser Name")}: ${Jobs.advertiserName}`}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {`${t("country")}: ${t(Jobs.country?Jobs.country:"-----")}`}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {`${t("Email")}: ${Jobs.email?Jobs.email:"-----"}`}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {`${t("phone")}: ${Jobs.phoneNumber?Jobs.phoneNumber:"-------"}`}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    {`${t("description")}: ${lang === "ar" ? Jobs.descriptionArabic : Jobs.descriptionEnglish}`}
                </Typography>
            </CardContent>
        </Card>
    );
}

JobCard.propTypes = {
    Jobs: PropTypes.shape({
        image: PropTypes.string,
        titleArabic: PropTypes.string,
        titleEnglish: PropTypes.string,
        advertiserName: PropTypes.string,
        country: PropTypes.string,
        email: PropTypes.string,
        phoneNumber: PropTypes.string,
        descriptionArabic: PropTypes.string,
        descriptionEnglish: PropTypes.string,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
    }).isRequired,
};

export default JobCard;
